import { render, staticRenderFns } from "./nuevaIncidenciaMultiple.vue?vue&type=template&id=aa70963a&"
import script from "./nuevaIncidenciaMultiple.vue?vue&type=script&lang=js&"
export * from "./nuevaIncidenciaMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports